import { render, staticRenderFns } from "./FacturarDialogComisiones.vue?vue&type=template&id=60473426&scoped=true"
import script from "./FacturarDialogComisiones.vue?vue&type=script&lang=js"
export * from "./FacturarDialogComisiones.vue?vue&type=script&lang=js"
import style0 from "./FacturarDialogComisiones.vue?vue&type=style&index=0&id=60473426&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60473426",
  null
  
)

export default component.exports